import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import TrafficDisplayGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Display/TrafficDisplayGrid';
import TrafficDisplayKeyMetricCards from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Display/TrafficDisplayKeyMetricCards';
import TrafficDisplayTrendChart from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Display/TrafficDisplayTrendChart';
import { useTrafficAvailability } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Total/hooks/useTrafficAvailability';
import { TrafficNoDataPlaceholder } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Total/pages/NonTopicOrTopicGroupPage';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';

/**
 * Simple wrapper for the traffic display page visualizations for Beacon Pro
 */
export const TrafficDisplayPage = () => {
  const { dataAvailable } = useTrafficAvailability();
  return (
    <BasePageContainer sx={{ marginTop: 0, gap: `${BEACON_CHART_SPACING}px` }}>
      {dataAvailable ? (
        <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
          <TrafficDisplayKeyMetricCards />
          <TrafficDisplayTrendChart />
          <TrafficDisplayGrid />
        </Flex>
      ) : (
        <TrafficNoDataPlaceholder />
      )}
    </BasePageContainer>
  );
};
